<template>
  <div class="invoice-records-container">
    <div class="card-title" style="margin-top: 20px;">
      开票记录
    </div>
    <div class="formCard default-table">
      <el-table :data="tableData" show-summary>
        <el-table-column label="序号" align="center" type="index" width="80"/>
        <el-table-column label="开票金额" prop="amount_money" align="center" width="160" sortable></el-table-column>
        <el-table-column label="记录人" prop="creator" align="center" sortable></el-table-column>
        <el-table-column label="记录时间" prop="invoice_at" align="center" sortable></el-table-column>
        <el-table-column label="修改时间" prop="updated_at" align="center" sortable></el-table-column>
        <el-table-column label="备注" prop="remark" align="center" sortable></el-table-column>
        <el-table-column v-if="userAuth.can_delete_invoice_record" label="操作" prop="remark" align="center">
          <template slot-scope="scope">
            <el-popover placement="top" width="430" :ref="`popover-${scope.row.id}`">
              <p>该操作将重新计算关联订单的开票金额、状态、时间，确定删除吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="sureOrCancel(scope.row.id,false)">取消</el-button>
                <el-button type="primary" size="mini" @click="sureOrCancel(scope.row.id,true)">确定</el-button>
              </div>
              <el-button v-if="!scope.row.source_id" type="text" slot="reference" class="del-btn">删除</el-button>
              <span v-else>-</span>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {queryInvoiceRecordByOrderId, invoiceRecordDestroy} from "@/api/order";

/**
 * 开票记录
 */
export default {
  name: "InvoiceRecords",
  props: {
    orderId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  watch: {
    orderId() {
      this.getData()
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const response = await queryInvoiceRecordByOrderId({order_id: this.orderId});
      this.tableData = response.model || []
      this.tableData.map(_ => {
        _.popDel = false
      })
    },
    /**
     * 删除开票记录
     * @param id
     * @param isSure
     */
    async sureOrCancel(id, isSure) {
      this.$refs["popover-" + id].showPopper = false;
      if (!isSure) {
        return false;
      }
      const response = await invoiceRecordDestroy({id: id});
      if (!response.success) {
        this.$message.error(response.message || '系统服务异常');
        return false
      }
      this.$message.success('操作成功')
      this.getData()
    }
  },
}
</script>
<style lang="scss">
.invoice-records-container {
  .del-btn {
    padding: 0;
  }
}
</style>
